/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_BUY_PANEL_PRODUCT_IMAGE = "SET_BUY_PANEL_PRODUCT_IMAGE";
export const SET_START_OVER_PRODUCT_IMAGE = "SET_START_OVER_PRODUCT_IMAGE";
export const SET_FAVORITES_PRODUCT_IMAGE = "SET_FAVORITES_PRODUCT_IMAGE";
